import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../reducers/form';
import { getMachineById, updMachine } from '../../../api/list'
import { fetchDispath } from '../../../functions/fetch'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'
import { typeMachine } from '../../../enum/type-machine.enum'

export default function MachineEdit({ history, match }) {
  const formName = 'MachineEdit'
  const dispatch = useDispatch()
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  useEffect(() => {
    dispatch(actions.formInitialize({
      model: '',
      typeM: '',
      govNumber: '',
      fuelConsumption: '',
      errorValidate: { name: false }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDispath({
      progress: true,
      request: getMachineById,
      param: {
        id: match.params.id
      }
    })).then(res => {
      dispatch(actions.formChangeAsObj({
        model: res.get.model,
        typeM: res.get.typeM,
        valuetypeM: { value: res.get.typeM, label: res.get.typeM },
        govNumber: res.get.govNumber,
        fuelConsumption: res.get.fuelConsumption,
      }, { name: formName }))
    }).catch(err => console.log(err))
  }, [dispatch, match.params.id])
  const arrProps = [
    { bp: { md: 6, sm: 12 }, field: 'typeM', type: 'autoArr', label: 'Тип техники', textProps: { arr: typeMachine } },
    { bp: { md: 6, sm: 12 }, field: 'model', type: 'text', label: 'Модель' },
    { bp: { md: 6, sm: 12 }, field: 'govNumber', type: 'text', label: 'Гос. номер' },
    { bp: { md: 6, sm: 12 }, field: 'fuelConsumption', type: 'text', label: 'Норма потребления топлива', textProps: { type: 'number' } },
  ]
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        typeM: values.typeM,
        model: values.model,
        govNumber: values.govNumber,
        fuelConsumption: values.fuelConsumption
      },
      url: updMachine.path({ id: match.params.id }),
      method: updMachine.type,
      history: history
    }, formName))
  }
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd
            arr={arrProps}
            formName={formName}
            title='Изменить технику'
            gridProps={{ xs: 12, xl: 9, lg: 10 }}
          />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Изменить</Button>
      </form>
    </div>
  );
}